import { useTheme } from '@emotion/react'

import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import GettingStarted from '@segment/templates/GettingStarted'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'

import Logos from './components/Logos'

import IndustryLeadingSecurity from './components/IndustryLeadingSecurity'

import Testimonials from './components/Testimonials'

import MakeDataDrivenDecisions from './components/MakeDataDrivenDecisions'

import DefineDetectValidate from './components/DefineDetectValidate'

import UncoverKeyMoments from './components/UncoverKeyMoments'

import UseSegment from './components/UseSegment'

import OgImagePng from './assets/OgHealthcare.png'

const HealthcareView = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Industries | Healthcare & Life Sciences | Twilio Segment"
        pageDescription="Unlock patient and member data with Twilio Segment for Healthcare. Engage patients with personalized experiences designed to retain and improve health outcomes—all while remaining HIPAA compliant."
        pageOG={OgImagePng}
        bodyBackground={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Hero />
        <Main>
          <Logos />
          <MakeDataDrivenDecisions />
          <DefineDetectValidate />
          <UncoverKeyMoments />
          <IndustryLeadingSecurity />
          <UseSegment />
          <Testimonials />
          <GettingStarted />
        </Main>
        <Footer />
      </Layout>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default HealthcareView
